import { useCallback, useEffect, useState } from 'react';
import { getErWallet } from '../../../../../api/wallet';

export const useErWallet = () => {
  const [data, setData] = useState<{ id: number; value: number }[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchData = useCallback(() => {
    setIsLoading(true);
    getErWallet()
      .then((res) => setData(res))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, isLoading };
};
